import { getNoteAtPosition, noteToSemitones, type NoteName } from "../guitarEngine";
import type { FretPosition } from "./types";

/** MIDI a partir de nombre + octava (igual que convención interna del motor). */
export function noteOctaveToMidi(note: NoteName, octave: number): number {
  return (octave + 1) * 12 + noteToSemitones(note);
}

/** ¿La nota detectada coincide con la posición esperada en el mástil? */
export function midiMatchesPosition(
  detectedMidi: number,
  position: FretPosition,
  toleranceSemis = 0.55,
): boolean {
  const expected = getNoteAtPosition(position.string, position.fret).midi;
  return Math.abs(detectedMidi - expected) <= toleranceSemis;
}

export function findMatchingPosition(
  detectedMidi: number,
  positions: FretPosition[],
): FretPosition | undefined {
  return positions.find((p) => midiMatchesPosition(detectedMidi, p));
}
